/** Las dos puntuaciones más altas de la campaña (p. ej. 3 y 4). */
export function isPromoterScore(
  score: number | null | undefined,
  campaignScores: { score: number }[] = [],
): boolean {
  if (score == null || score <= 0) {
    return false;
  }

  if (campaignScores.length >= 2) {
    const topTwo = [...campaignScores]
      .map((item) => item.score)
      .sort((a, b) => b - a)
      .slice(0, 2);

    return topTwo.includes(score);
  }

  return score === 3 || score === 4;
}

/** Estrellas mostradas en el modal de Google Play según la votación. */
export function getPlayStoreStarCount(score: number): number {
  if (score === 3) {
    return 4;
  }

  if (score === 4) {
    return 5;
  }

  return Math.min(5, Math.max(1, score + 1));
}

/** Decodifica entidades HTML del emoji devuelto por la API (ej. &#128578;). */
export function decodeSurveyEmoji(emoji: string | null | undefined): string {
  if (!emoji) {
    return '';
  }

  if (typeof document === 'undefined') {
    return emoji;
  }

  const textarea = document.createElement('textarea');
  textarea.innerHTML = emoji;
  return textarea.value;
}
